import {
  GetSolutionsQuery,
  proStudioUrqlGql as urqlGql,
} from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import {
  ProStudioContext,
  ProStudioEvents,
  SelectedSolution,
} from '../prostudio.xstate.types';
import { uploadSolutionFiles } from './helpers';
import { GetBotData } from '../prostudio.api-service.types';

export const createBot = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  botName: string;
  selectedSolution: SelectedSolution;
  solutions: NonNullable<GetSolutionsQuery['admin_']>['solutions'];
  cb: (path?: string) => void;
} | void> => {
  if (event.type !== 'createCustomerBot') {
    return;
  }

  const projectProStudioSettingId = ctx.project?.projectProStudioSetting?.id;
  const { customerId, project } = ctx;
  const projectId = project?.id;

  if (!projectId || !projectProStudioSettingId) {
    throwErrorWithId('Project ID and projectProStudioSettingId are required');
    return;
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  const resp = await urqlGql.createSolution({
    projectProStudioSettingId,
    solution: {
      name: event.payload.botName,
    },
    version: event.payload.version,
    createDefaultChannels: true,
  });

  checkForErrors(resp);

  const { data: respData } = resp;
  if (!respData) {
    throwErrorWithId('Failed to create solution');
    return;
  }

  if (event?.payload.files?.length > 0) {
    const solutionVersionId =
      respData.admin_?.createSolution?.solutionVersions?.[0]?.id;
    if (solutionVersionId) {
      void uploadSolutionFiles(solutionVersionId, event.payload.files);
    }
  }

  const solutionsResponse = await urqlGql.getSolutions({
    projectProStudioSettingId,
  });

  checkForErrors(solutionsResponse);

  const { data: solutionsData } = solutionsResponse;

  const solutions = solutionsData?.admin_?.solutions;

  const createdSolutionId = respData.admin_?.createSolution?.botSolutionId;

  if (!createdSolutionId) {
    throwErrorWithId('Created solution ID is required');
    return;
  }

  const botResponse = await urqlGql.getBotById({
    botId: createdSolutionId,
    projectId,
  });

  checkForErrors(botResponse);

  const botData = botResponse.data?.getBotById
    ?.data as GetBotData['getBotById']['data'];

  if (!botData) {
    throwErrorWithId('Bot data is required');
    return;
  }
  return {
    botName: respData.admin_?.createSolution?.name || '',
    selectedSolution: {
      ...botData,
      displayName: event.payload.botName || '',
      uniqueId: respData.admin_?.createSolution?.id || '',
    },
    solutions,
    cb: event.cb,
  };
};
